// extracted by mini-css-extract-plugin
export default {"container":"calculator_container__aF68O","breadCrumb":"calculator_breadCrumb__qisCP"};